import {
  Skeleton,
  TableCell,
  TableHead,
} from "@rarible_int/anaconda_ui_components"

interface CellProps {
  children: React.ReactNode
}

export function HeaderCell({ children }: CellProps) {
  return (
    <TableHead className="w-[140px] text-nowrap p-2 text-right text-xs">
      {children}
    </TableHead>
  )
}

export function StickyHeaderCell({ children }: CellProps) {
  return (
    <TableHead className="sticky left-0 w-[200px] text-nowrap p-2 text-xs md:w-[280px]">
      {children}
    </TableHead>
  )
}

export function Cell({ children }: CellProps) {
  return <TableCell className="w-[140px] p-0 text-right">{children}</TableCell>
}

export function StickyCell({ children }: CellProps) {
  return (
    <TableCell className="sticky left-0 w-[200px] p-0 md:w-[280px]">
      {children}
    </TableCell>
  )
}

export function CellSkeleton() {
  return (
    <div className="flex items-center justify-end">
      <Skeleton className="h-6 w-20" />
    </div>
  )
}
